import type {CreateComputedOptions, CreateSignalOptions, Signal} from "@angular/core";
import {computed, isSignal, signal} from "@angular/core";

export type SignalOrValue<T> = Signal<T> | T;

export function readSignalOrValue<T>(item: SignalOrValue<T>): T {
  return isSignal(item) ? item() : item;
}

export function toSignal<T>(item: SignalOrValue<T>, options?: Readonly<CreateSignalOptions<T>>): Signal<T> {
  return isSignal(item) ? item : signal(item, options);
}

export function computedFromSignalOrValue<T, U>(
  item: SignalOrValue<T>,
  compute: (value: T) => U,
  options?: Readonly<CreateComputedOptions<U>>): Signal<U> {
  return isSignal(item) ? computed(() => compute(item()), options) : signal(compute(item));
}
